"use strict";

module.exports = {
  'name': 'norm',
  'category': 'Arithmetic',
  'syntax': ['norm(x)', 'norm(x, p)'],
  'description': 'Calculate the norm of a number, vector or matrix.',
  'examples': ['abs(-3.5)', 'norm(-3.5)', 'norm(3 - 4i)', 'norm([1, 2, -3], Infinity)', 'norm([1, 2, -3], -Infinity)', 'norm([3, 4], 2)', 'norm([[1, 2], [3, 4]], 1)', 'norm([[1, 2], [3, 4]], "inf")', 'norm([[1, 2], [3, 4]], "fro")']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/arithmetic/norm.js
// module id = 847
// module chunks = 0